import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
(function (){
    window.Swiper = Swiper;
    window.SwiperNavigation = Navigation;
})();
